export default {
  name: 'shop-intro',
  label: {
    title: '店铺简介',
    icon: require('@/assets/icon-component-label_ShopIntro.svg'),
    limit: 1
  },
  tip: '注意：此模块只在店铺首页显示，微页面中不显示',
  decor_type: 'seller',
  sort: 2001
}
